import $ from 'jquery';
import TweenMax from 'gsap/TweenMax';
import ScrollMagic from 'scrollmagic';
import 'jquery-scrollify';
import {
  setCookie
} from './util/util';
import SingletonModel from './model/singletonModel';
import Layer from './module/Layer';
import Intro from './page/Intro';
import Record from './page/Record';

(function () {
  'use strict';

  // variables
  let scrollMagicCon, intro, record;

  const $body = $('body');

  const model = SingletonModel.getInstance();

  // implement
  $(document).ready(init);

  function init() {
    scrollMagicCon = new ScrollMagic.Controller();

    intro = new Intro('#sectionIntro', scrollMagicCon);
    record = new Record('#sectionRecord', scrollMagicCon);

    // if ($('body').hasClass('pc')) {
    //   $.scrollify({
    //     section: '.section',
    //     easing: 'easeOutExpo',
    //     setHeights: false,
    //     updateHash: false
    //   });
    // }

    $.scrollify({
      section: '.section',
      easing: 'easeOutExpo',
      setHeights: false,
      updateHash: false
    });

    setBtns();
    setLayers();
    setEvents();
  }

  function setBtns() {
    // hide tooltip of btn after delay
    if ($body.hasClass('mobile') || $body.hasClass('tablet')) {
      hideTooltipAfterDelay(1000, $('.go-home .text'), 0.5);
    }

    hideTooltipAfterDelay(1000, $('.appdownload-wrap .btn-appdownload .text'), 0.5);
    scrollDownBtn('.scrolldown');
  }

  function setEvents() {
    $(window).on('resize', evt => {
      if (intro) intro.resize(evt);
      if (record) intro.resize(evt);
    });

    $('.go-home').on('click', (evt) => {
      evt.preventDefault();
      setCookie('LineageM_WEB_VISIT_190213', false, 1);
      location.href = $('.go-home').attr('href');
    });
  }

  function setLayers() {
    //이벤트 유의사항 레이어
    $('[data-module-id="layer"]').on('click', function (evt) {
      evt.preventDefault();
      evt.stopPropagation();

      const $btn = $(this),
        layerSelector = $btn.attr('data-layer-target');

      console.log('layerSelector :', layerSelector);

      const _ = this;
      _.model = SingletonModel.getInstance();

      const layer = _.model.modalLayers[layerSelector];
      console.log('layer :', layer);

      if (layer) {
        layer.show();
      } else {
        _.model.modalLayers[layerSelector] = new Layer({
          layer: $(layerSelector),
          linked: $btn,
          options: {
            noScroll: false,
            keepDimmed: true
          },
          onBeforeShow: function () {
            console.log('onBeforeShow show modal layer');

            enableScrollMagicScenes(false);

            _.model.isShowBodyFixedLayer = true;
          },
          onBeforeHide: function () {
            console.log('onBeforeHide show modal layer');

            enableScrollMagicScenes(true);

            _.model.isShowBodyFixedLayer = false;
          },
          onShow: function () {
            console.log('onShowCallback');
          }
        });
      }
    });
  }

  function hideTooltipAfterDelay(delay, $ele, speed = 0.5) {
    window.setTimeout(function () {
      TweenMax.to($ele, speed, {
        autoAlpha: 0,
        // ease: Cubic.easeOut,
        onComplete: () => {
          $ele.hide();
        }
      });
    }, delay);
  }

  function enableScrollMagicScenes(flag) {
    model.pages.map(page => {
      page.enabledScrollMagicScene(flag);
      // page.getScrollMagicScene().enabled(flag);
    });
  }

  // function moveAnchor(target) {
  //     let $target = jQuery(target);

  //     jQuery('html, body').stop().animate({
  //         scrollTop: $target.offset().top + 'px'
  //     });
  // }

  function scrollDownBtn(target) {
    let $targetClass = jQuery(target);
    $targetClass.on('click', (evt) => {
      evt.preventDefault();

      const targetLink = jQuery(evt.target).attr('href');

      if (targetLink) {
        jQuery('html, body').stop().animate({
          scrollTop: jQuery(targetLink).offset().top + 'px'
        });
      }
    });
    console.log('scrollDown');
  }

  // moveAnchor(target) {
  //     let $target = jQuery(target);

  //     jQuery('html, body').stop().animate({
  //         scrollTop: $target.offset().top + 'px'
  //     });
  // }

  // openLayer
  window.openLayer = function (layerSelector) {
    console.log('layerSelector :', layerSelector);

    new Layer({
      layer: $(layerSelector),
      // linked: $btn,
      options: {
        noScroll: false,
        keepDimmed: true
      },
      onBeforeShow: function () {
        console.log('onBeforeShow show modal layer');
      },
      onBeforeHide: function () {
        console.log('onBeforeHide show modal layer');
      },
      onShow: function () {
        console.log('onShowCallback');
      }
    });
  };

})();